import React, { useEffect, useState } from 'react';
import './LanguageLocalization.scss';

export default function LanguageLocalization(): React.ReactElement {
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  useEffect(() => {
    const customSelect = document.querySelector('.custom-select');
    const selectBtn = document.querySelector('.select-button');

    const selectedValue = document.querySelector('.selected-value');
    const optionsList = document.querySelectorAll('.select-dropdown li');

    // add click event to select button
    selectBtn.addEventListener('click', () => {
      // add/remove active class on the container element
      customSelect.classList.toggle('active');
      // update the aria-expanded attribute based on the current state
      selectBtn.setAttribute('aria-expanded', selectBtn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });

    optionsList.forEach((option) => {
      function handler(e) {
        // Click Events
        if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
          selectedValue.textContent = this.children[1].textContent;
          customSelect.classList.remove('active');
        }
        // Key Events
        if (e.key === 'Enter') {
          selectedValue.textContent = this.textContent;
          customSelect.classList.remove('active');
        }
      }

      option.addEventListener('keyup', handler);
      option.addEventListener('click', handler);
    });
  }, []);

  useEffect(() => {
    localStorage.setItem('docsLanguage', selectedLanguage);
  }, [selectedLanguage]);

  return (
    <div className="custom-select">
      <button className="select-button">
        <span className="selected-value">{selectedLanguage}</span>
        <span className="arrow"></span>
      </button>
      <ul className="select-dropdown" role="listbox" id="select-dropdown">
        <li onClick={() => setSelectedLanguage('en')}>
          <input type="radio" id="en" name="en" />
          <label htmlFor="en">En</label>
        </li>
        <li onClick={() => setSelectedLanguage('de')}>
          <input type="radio" id="de" name="de" />
          <label htmlFor="de">De</label>
        </li>
        <li onClick={() => setSelectedLanguage('pt')}>
          <input type="radio" id="pt" name="pt" />
          <label htmlFor="pt">Pt</label>
        </li>
      </ul>
    </div>
  );
}
